import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate("/admin/login");
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: res.data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Sign-in failed.";
        setError(msg);
        setTimeout(() => navigate("/admin/login", { state: { error: msg } }), 1800);
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-alabaster" data-testid="auth-callback">
      <div className="text-center">
        <div className="overline mb-3">Aikyam</div>
        {error ? (
          <p className="text-[var(--danger)] max-w-md px-6">{error}</p>
        ) : (
          <p className="text-[var(--text2)]">Verifying your credentials…</p>
        )}
      </div>
    </div>
  );
}
